import { MondayLogo } from "frontend/icons/icons";
import style from "./convert-menu.module.css";

function renderItemIcon() {
  return (
    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 3.13144C1 1.95428 1.95428 1 3.13145 1H13.3267C14.5039 1 15.4582 1.95428 15.4582 3.13145V10.4351C15.4582 11.6122 14.5039 12.5665 13.3267 12.5665H3.13144C1.95428 12.5665 1 11.6122 1 10.4351V3.13144Z"
        stroke="white"
        strokeWidth="1.02309"
      />
      <line x1="4.40315" y1="1" x2="4.40315" y2="12.5665" stroke="white" strokeWidth="1.02309" />
      <rect x="6.06055" y="3.8916" width="7.22908" height="0.867489" rx="0.433745" fill="white" />
    </svg>
  );
}

function renderSubitemIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.86719 0.807739C3.1073 0.856734 3.28786 1.0698 3.28809 1.32434C3.28809 1.57902 3.10736 1.79185 2.86719 1.84094L2.76172 1.85168H2.17188V5.26575H7.07422V4.6554C7.07422 4.17036 7.46809 3.77649 7.95312 3.77649H12.4629C12.9479 3.77656 13.3408 4.17041 13.3408 4.6554V6.93079C13.3406 7.41559 12.9477 7.80962 12.4629 7.80969H7.95312C7.46823 7.80969 7.07444 7.41563 7.07422 6.93079V6.32043H2.17188V11.2228H7.07422V10.6124C7.07422 10.1274 7.46809 9.73352 7.95312 9.73352H12.4629C12.9479 9.73359 13.3408 10.1274 13.3408 10.6124V12.8878C13.3408 13.3728 12.9478 13.7667 12.4629 13.7667H7.95312C7.46813 13.7667 7.07428 13.3728 7.07422 12.8878V12.2765H1.64453C1.35351 12.2765 1.11719 12.0402 1.11719 11.7491V1.85168H0.527344C0.236324 1.85168 0 1.61536 0 1.32434C0.000253849 1.03354 0.23648 0.796997 0.527344 0.796997H2.76172L2.86719 0.807739ZM8.12891 12.713H12.2871V10.7882H8.12891V12.713ZM8.12891 6.75598H12.2871V4.83118H8.12891V6.75598Z"
        fill="white"
      />
    </svg>
  );
}

export function ConvertToMondayItemPopup({
  onConvertToMondayItem,
  closePopup,
}: {
  onConvertToMondayItem: (itemType: "item" | "subitem") => void; // TODO: Remove in the future in favor of context.
  closePopup: () => void;
}) {
  return (
    <div className={style.container}>
      <div className={style.header}>
        <MondayLogo size={20} />
        <span className={style.title}>Convert to monday item</span>
      </div>
      <div className={style.description}>
        Stay in sync - updates reflect instantly <br /> in both monday.com and here
      </div>

      <div className={style.divider} />

      <div className={style.buttonRow}>
        <button
          className={style.button}
          data-testid="convertToMondayItemOption"
          onClick={() => {
            onConvertToMondayItem("item");
            closePopup();
          }}
        >
          {renderItemIcon()} Convert to monday item
        </button>
        <button
          className={style.button}
          data-testid="convertToMondaySubitemOption"
          onClick={() => {
            onConvertToMondayItem("subitem");
            closePopup();
          }}
        >
          {renderSubitemIcon()} Convert to monday subitem
        </button>
      </div>
    </div>
  );
}
